import { render, staticRenderFns } from "./MWEMonthly.vue?vue&type=template&id=1489b997"
import script from "./MWEMonthly.vue?vue&type=script&lang=js"
export * from "./MWEMonthly.vue?vue&type=script&lang=js"
import style0 from "./MWEMonthly.vue?vue&type=style&index=0&id=1489b997&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports